export const PENDING_CALL_SECURE_TIMEOUT = 35000;
export const PENDING_PAYMENT_TIMEOUT = 60000;

export const AUTHENTICATION_RETRIES = 3;
